import React from 'react'
import isEqual from 'lodash/isEqual'
import ReactSelect, { OptionTypeBase } from 'react-select'
import { Form } from 'lib/ui/components'
import { CATALOG_SORT } from 'lib/core/resources/constants'
import { SORT_BY } from 'resources/constants'
import { useProductListPage } from 'lib/modules/catalog'
import { MagentoSortField } from 'lib/types'

interface Props {
  categoryId: number
  handleSortChange: (value: any) => void
}

export const CategorySort = ({ categoryId, handleSortChange }: Props) => {
  const {
    sortOptions,
    currentSort
  } = useProductListPage({ categoryId })

  const finalSortOptions: any = getSortOptions(sortOptions)

  return (
    <>
      <label>Sort By</label>
      <ReactSelect
        options={finalSortOptions}
        onChange={handleSortChange}
        classNamePrefix={Form.ReactSelectTheme.classNamePrefix}
        value={getSortValue(currentSort, finalSortOptions)}
      />
    </>
  )
}

const getSortOptions = (sortOptions: MagentoSortField[] = []): OptionTypeBase[] => {
  const optionsFiltered: OptionTypeBase[] = sortOptions.filter((sortOption) => {
    return SORT_BY.includes(sortOption.value)
  })

  const options: OptionTypeBase[] = []

  optionsFiltered.forEach(option => {
    const { label, value } = option
    options.push({
      label: value === 'name' ? `${label} A to Z` : `${label} Low to High`,
      value: [value, CATALOG_SORT.ASC]
    })
    options.push({
      label: value === 'name' ? `${label} Z to A` : `${label} High to Low`,
      value: [value, CATALOG_SORT.DESC]
    })
  })

  return options
}

const getSortValue = (value: any[] = [], options: any[] = []) => {
  return options.find((obj: any) => isEqual(obj.value, value))
}
